(() => {
  'use strict';
  function loadMedia(element) {
    if (element.dataset.nrSrc) {
      element.src = element.dataset.nrSrc;
      delete element.dataset.nrSrc;
    }
    if (element.dataset.nrPoster) {
      element.poster = element.dataset.nrPoster;
      delete element.dataset.nrPoster;
    }
  }
  document.querySelectorAll('testimonial-slider .ts-marquee-track').forEach(track => {
    const photos = [...track.querySelectorAll('img')];
    const photoUrl = image => image.dataset.nrSrc || image.src;
    const repeat = photos.findIndex((image, index) => index > 0 && photoUrl(image) === photoUrl(photos[0]));
    if (repeat < 1) return;
    const updateLoop = () => {
      const distance = photos[repeat].offsetLeft - photos[0].offsetLeft;
      if (distance > 0) track.style.setProperty('--nr-photo-loop', `${-distance}px`);
    };
    updateLoop();
    window.addEventListener('resize', updateLoop, { passive: true });
  });
  const deferredMedia = document.querySelectorAll('[data-nr-src],[data-nr-poster]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadMedia(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '220px' });
    deferredMedia.forEach(element => observer.observe(element));
  } else deferredMedia.forEach(loadMedia);
  const gallery = document.querySelector('[data-carousel-main]');
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.nr-oregano-page .swiper').forEach(element => {
      if (element.swiper) {
        // CSS removes transitions; Swiper must finish navigation synchronously.
        element.swiper.params.speed = 0;
        element.swiper.originalParams.speed = 0;
      }
    });
  }
  function preloadGalleryNeighbors() {
    const slides = [...gallery.querySelectorAll('.swiper-slide')];
    const active = Math.max(0, slides.findIndex(slide => slide.classList.contains('swiper-slide-active')));
    slides.slice(Math.max(0, active - 1), active + 2).forEach(slide => slide.querySelectorAll('[data-nr-src]').forEach(loadMedia));
  }
  if (gallery) {
    preloadGalleryNeighbors();
    new MutationObserver(preloadGalleryNeighbors).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  let selected = 2;
  const offers = [...document.querySelectorAll('[data-nr-offer-form]')];
  function setOffer(quantity) {
    if (![1, 2].includes(quantity)) return;
    selected = quantity;
    for (const offer of offers) {
      for (const row of offer.querySelectorAll('[data-nr-offer]')) {
        const active = Number(row.dataset.nrOffer) === quantity;
        row.classList.toggle('active', active);
        row.querySelector('input[type="radio"]').checked = active;
      }
      for (const input of offer.querySelectorAll('[data-nr-quantity]')) {
        input.value = String(quantity);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      for (const compare of offer.querySelectorAll('[data-nr-compare]')) compare.hidden = quantity === 1;
    }
    document.dispatchEvent(new CustomEvent('nr-oregano:offer', { detail: { quantity } }));
  }
  for (const offer of offers) {
    offer.addEventListener('change', event => {
      if (event.target.matches('.nr-offer-radio')) setOffer(Number(event.target.value));
    });
  }
  setOffer(2);
  function openCod() {
    setOffer(selected);
    const native = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
    if (native) native.click();
    else document.querySelector('[data-nr-offer-form="main"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.querySelectorAll('[data-nr-open-cod]').forEach(button => button.addEventListener('click', openCod));
  document.querySelector('form[data-nr-offer-form]')?.addEventListener('submit', event => {
    event.preventDefault();
    openCod();
  });
  function localizeNavigation() {
    document.querySelectorAll('[aria-label]').forEach(element => {
      const label = element.getAttribute('aria-label');
      if (label === 'Previous slide') element.setAttribute('aria-label', 'Diapositivo anterior');
      else if (label === 'Next slide') element.setAttribute('aria-label', 'Diapositivo seguinte');
      else if (label === 'Primary') element.setAttribute('aria-label', 'Navegação principal');
      else if (label.startsWith('Go to slide ')) element.setAttribute('aria-label', label.replace('Go to slide ', 'Ir para o diapositivo '));
    });
  }
  localizeNavigation();
  new MutationObserver(localizeNavigation).observe(document.querySelector('.nr-oregano-page'), {
    subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label']
  });
  document.querySelectorAll('.faq-item .faq-questions').forEach((button, index) => {
    const answer = button.closest('.faq-item').querySelector('.faq-answers');
    if (!answer) return;
    answer.id = `nr-oregano-answer-${index}`;
    button.type = 'button';
    button.setAttribute('aria-controls', answer.id);
    button.setAttribute('aria-expanded', 'false');
    answer.hidden = true;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      button.closest('.faq-item').classList.toggle('active', open);
      answer.hidden = !open;
      answer.style.height = open ? 'auto' : '';
      answer.style.display = open ? 'block' : '';
      const icon = button.querySelector('.toggle-icons');
      if (icon) icon.textContent = open ? '−' : '+';
    });
  });
  const search = document.querySelector('.site-header__search-container');
  document.querySelectorAll('.js-search-header, .js-search-header-close').forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    if (search) search.classList.toggle('is-active');
  }));
  const footerButton = document.querySelector('button.footer__title.collapsible-trigger');
  if (footerButton) {
    const content = document.getElementById(footerButton.getAttribute('aria-controls'));
    footerButton.setAttribute('aria-expanded', 'true');
    footerButton.addEventListener('click', () => {
      const open = footerButton.getAttribute('aria-expanded') !== 'true';
      footerButton.setAttribute('aria-expanded', String(open));
      content.hidden = !open;
    });
    matchMedia('(min-width:769px)').addEventListener('change', event => {
      if (event.matches) {
        content.hidden = false;
        footerButton.setAttribute('aria-expanded', 'true');
      }
    });
  }
  let attempts = 0;
  const checkNative = setInterval(() => {
    const native = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
    if (native) {
      native.style.setProperty('background-color', '#009370', 'important');
      native.style.setProperty('font-family', 'Satoshi, sans-serif', 'important');
      clearInterval(checkNative);
    } else if (++attempts >= 25) {
      clearInterval(checkNative);
      const status = document.querySelector('[data-nr-offer-form="main"] .nr-order-status');
      if (status) status.textContent = window.nrOregano?.available ? 'O pagamento na entrega está temporariamente indisponível. Tenta novamente dentro de instantes.' : 'Em breve disponível.';
    }
  }, 400);
})();
